import { CancelableRequest } from '@fino/ng1-request';
import { DataResponse } from '@fino/ng1-response/src/dataResponse';

export class BankSearchService extends CancelableRequest {
  constructor($http, $q, appConfig) {
    'ngInject';
    super({ $http, $q, appConfig });
  }

  createBankUrl(url, term, limit = 10) {
    return `${url}/banks/${term}?limit=${limit}`;
  }

  getBanks(term, url) {
    return this.$http({
      method: 'GET',
      url: this.createBankUrl(url, term),
    }).then(DataResponse.transform('data.banks'));
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-bank-search/src/bankSearch.service.js